/**
 * @generated SignedSource<<d9fbf8dccf2e36f22f44ebf93e5d7576>>
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type CompetitionOverviewPageLegacyDescriptionFragment$data = {
  readonly description: string | null | undefined;
  readonly host: {
    readonly " $fragmentSpreads": FragmentRefs<"HostCardFragment">;
  };
  readonly id: string;
  readonly timeline: {
    readonly " $fragmentSpreads": FragmentRefs<"TimelineFragment">;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"TagListFragment">;
  readonly " $fragmentType": "CompetitionOverviewPageLegacyDescriptionFragment";
};
export type CompetitionOverviewPageLegacyDescriptionFragment$key = {
  readonly " $data"?: CompetitionOverviewPageLegacyDescriptionFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"CompetitionOverviewPageLegacyDescriptionFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "CompetitionOverviewPageLegacyDescriptionFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "description",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Timeline",
      "kind": "LinkedField",
      "name": "timeline",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "TimelineFragment"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "host",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "HostCardFragment"
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TagListFragment"
    }
  ],
  "type": "Competition",
  "abstractKey": null
};

(node as any).hash = "78fcd684e93fd50030b82658f7ef2612";

export default node;
